export default __webpack_public_path__ + "static/media/orange.4b360091.jpg";